import React from 'react';

import styled from 'styled-components';

import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';

import { Button } from 'components';

const StyledButton = styled(Button)`
  text-indent: 1rem;
`;

type Props = {
  id?: string;
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
};

export const AddButton: React.FC<Props> = ({
  id,
  label,
  onClick,
  className,
  disabled,
}) => {
  return (
    <StyledButton
      id={id}
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      <AddBoxOutlinedIcon />
      {label}
    </StyledButton>
  );
};
